import { Dispatch, SetStateAction } from 'react';

import { Icon } from 'coreOld/elements';
import { ICompanyPart } from 'partsOld/types';

import { IconWrapper, ItemWrapper, Uom, UomLabel, Wrapper } from './uomsHeaderStyle';

interface IProps {
  part: Partial<ICompanyPart>;
  setIsEditOpen: Dispatch<SetStateAction<boolean>>;
}

const UomsHeaderView = ({ part, setIsEditOpen }: IProps) => {
  return (
    <Wrapper>
      <ItemWrapper>
        <UomLabel>Base</UomLabel>
        <Uom>{part?.uom}</Uom>
      </ItemWrapper>

      <ItemWrapper>
        <UomLabel>Purchase</UomLabel>
        <Uom>{part?.purchaseCostUom}</Uom>
      </ItemWrapper>

      <ItemWrapper>
        <UomLabel>Sales</UomLabel>
        <Uom>{part?.salesUom}</Uom>
      </ItemWrapper>

      <ItemWrapper>
        <UomLabel>Package</UomLabel>
        <Uom>{part?.packageUom}</Uom>
      </ItemWrapper>

      <ItemWrapper>
        <UomLabel>External/ERP</UomLabel>
        <Uom>{part?.externalUom}</Uom>
      </ItemWrapper>

      <IconWrapper onClick={() => setIsEditOpen(true)}>
        <Icon name={Icon.PENCIL} />
      </IconWrapper>
    </Wrapper>
  );
};

export default UomsHeaderView;
